// extracted by css-extract-rspack-plugin
export default {"tabs":"tabs___iHkrq_Um","tabs__list":"tabs__list___jiXZqxLp","tabs__trigger":"tabs__trigger___mn54pUZQ","tabs__content":"tabs__content___Zs6HNd8y"};